var _style, _feBlend, _feBlend2, _feBlend3, _feBlend4, _g, _g2, _feBlend5, _feBlend6, _g3, _path, _path2, _path3, _path4, _path5, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnplugged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.21 469.21",
    style: {
      enableBackground: "new 0 0 469.21 469.21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter_00000008857606110076567950000006333974527288803724_);}\n\t.st2{mask:url(#SVGID_1_);fill:url(#SVGID_00000074437931138930352260000008539821212686876293_);}\n\t.st3{fill:url(#SVGID_00000139253252573472775400000000297810837462634645_);}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_00000086676586205828688130000015984683150452271021_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000117669508727116152630000015645393066688467096_);}\n\n\t\t.st6{mask:url(#SVGID_00000126293369476272292710000014369575654050770873_);fill:url(#SVGID_00000047025054904273628590000015451390010901923212_);}\n\t.st7{fill:url(#SVGID_00000155129114795716674230000004828394338085407146_);}\n\t.st8{fill:#D8E2F4;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_00000152951485156981962390000001688497055859213241_);}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_00000003085276542296310240000015651625614680978830_);}\n\n\t\t.st12{mask:url(#SVGID_00000061447597560819232230000012034374203335071127_);fill:url(#SVGID_00000177443132724237226220000002821012465161740990_);}\n\t.st13{fill:url(#SVGID_00000166669888825176429350000017302541718225062812_);}\n\t.st14{fill:#3FB790;}\n\t.st15{fill:#34916F;}\n\t.st16{fill:#4FC7A0;}\n\t.st17{fill:#3FB690;}\n\t.st18{fill:#90DAD8;}\n\t.st19{fill:#D0DAED;}\n\t.st20{fill:#FFAA9D;}\n\t.st21{fill:url(#SVGID_00000176034872435009463220000011270313116036495011_);}\n\t.st22{fill:#0B2252;}\n\t.st23{fill:url(#SVGID_00000057140018225740259820000004022208843503884725_);}\n\t.st24{fill:#14336D;}\n\t.st25{fill:url(#SVGID_00000183948728865061495580000008274468481928347287_);}\n\t.st26{fill:#FF9F91;}\n\t.st27{fill:#14336A;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 469.21,
    height: 469.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 469.21,
    height: 469.21,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000151535910563222992590000000622615898791901629_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 469.21,
    height: 469.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 469.21,
    height: 469.21,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000151535910563222992590000000622615898791901629_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065758004477980332560000002595711510973053849_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.6035,
    y1: 422.5941,
    x2: 234.6035,
    y2: -46.6129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000065758004477980332560000002595711510973053849_)"
    },
    cx: 234.6,
    cy: 234.6,
    r: 234.6
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180341922137674326670000006169373154660652164_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.6035,
    y1: 422.5941,
    x2: 234.6035,
    y2: -46.6129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000180341922137674326670000006169373154660652164_)"
    },
    cx: 234.6,
    cy: 234.6,
    r: 234.6
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065041948742910924810000014239707492200242582_",
    filterUnits: "userSpaceOnUse",
    x: 1.23,
    y: 245.17,
    width: 466.74,
    height: 167.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.23,
    y: 245.17,
    width: 466.74,
    height: 167.53,
    id: "SVGID_00000087380537504004437490000006091312434125368244_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000065041948742910924810000014239707492200242582_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000036951140414688629150000015946012707130751623_",
    filterUnits: "userSpaceOnUse",
    x: 1.23,
    y: 245.17,
    width: 466.74,
    height: 167.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.23,
    y: 245.17,
    width: 466.74,
    height: 167.53,
    id: "SVGID_00000087380537504004437490000006091312434125368244_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000036951140414688629150000015946012707130751623_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058591664107151857250000015576586795217978757_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.6035,
    y1: 404.4185,
    x2: 234.6035,
    y2: 270.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000087380537504004437490000006091312434125368244_)",
      fill: "url(#SVGID_00000058591664107151857250000015576586795217978757_)"
    },
    d: " M467.97,264.43c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 C5.32,309.83,31,362.58,70.39,401.49c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C451.29,332.27,463.52,299.56,467.97,264.43z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151521697187950927720000004810894113557344171_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.6035,
    y1: 404.4185,
    x2: 234.6035,
    y2: 270.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151521697187950927720000004810894113557344171_)"
    },
    d: "M467.97,264.43 c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 C5.32,309.83,31,362.58,70.39,401.49c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C451.29,332.27,463.52,299.56,467.97,264.43z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M399.03,133.4H342.3c-3.32,0-6.35-1.2-8.7-3.19c-2.9-2.46-4.74-6.14-4.74-10.24v0c0-3.71,1.5-7.07,3.94-9.5 c2.43-2.43,5.79-3.94,9.5-3.94h56.73c3.71,0,7.07,1.5,9.5,3.94c2.43,2.43,3.94,5.79,3.94,9.5v0c0,3.71-1.5,7.07-3.94,9.5 C406.1,131.9,402.74,133.4,399.03,133.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0621 -0.9981 0.9981 0.0621 232.3931 469.0612)",
    className: "st8",
    cx: 365.78,
    cy: 110.88,
    rx: 20.36,
    ry: 20.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.7,100.87H52.45c-5.44,0-10.37-2.21-13.94-5.78c-3.57-3.57-5.78-8.5-5.78-13.94v0 c0-3.88,1.12-7.5,3.06-10.55c3.5-5.51,9.65-9.16,16.66-9.16h83.25c5.44,0,10.37,2.21,13.94,5.78c3.57,3.57,5.78,8.5,5.78,13.94v0 c0,5.08-1.92,9.71-5.08,13.21C146.73,98.36,141.51,100.87,135.7,100.87z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2538 -0.9673 0.9673 0.2538 -0.7426 134.6557)",
    className: "st9",
    cx: 86.9,
    cy: 67.81,
    rx: 29.88,
    ry: 29.88
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088834616907573072560000004415609113514862997_",
    filterUnits: "userSpaceOnUse",
    x: 97.62,
    y: 412.64,
    width: 308.79,
    height: 7.36
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 97.62,
    y: 412.64,
    width: 308.79,
    height: 7.36,
    id: "SVGID_00000159462728513474645980000005299007552525665162_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000088834616907573072560000004415609113514862997_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000098934978503930169960000013620169135380635271_",
    filterUnits: "userSpaceOnUse",
    x: 97.62,
    y: 412.64,
    width: 308.79,
    height: 7.36
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 97.62,
    y: 412.64,
    width: 308.79,
    height: 7.36,
    id: "SVGID_00000159462728513474645980000005299007552525665162_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000098934978503930169960000013620169135380635271_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173155278528016096700000017030223410507303068_",
    cx: 446.1702,
    cy: 602.5749,
    r: 142.125,
    gradientTransform: "matrix(1.1255 0 0 1.145 -250.1492 -273.6296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000159462728513474645980000005299007552525665162_)",
      fill: "url(#SVGID_00000173155278528016096700000017030223410507303068_)"
    },
    d: " M406.41,416.32c0,2.03-69.12,3.68-154.39,3.68c-85.27,0-154.39-1.65-154.39-3.68c0-2.03,69.12-3.68,154.39-3.68 C337.28,412.64,406.41,414.29,406.41,416.32z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000158718540019918753020000010673360423346523804_",
    cx: 446.1702,
    cy: 602.5749,
    r: 142.125,
    gradientTransform: "matrix(1.1255 0 0 1.145 -250.1492 -273.6296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0DFF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872,
    style: {
      stopColor: "#D0DFF3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158718540019918753020000010673360423346523804_)"
    },
    d: "M406.41,416.32 c0,2.03-69.12,3.68-154.39,3.68c-85.27,0-154.39-1.65-154.39-3.68c0-2.03,69.12-3.68,154.39-3.68 C337.28,412.64,406.41,414.29,406.41,416.32z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M346.41,332.62c-0.65,3.25,3.25,3.9,3.9,8.46c0.65,4.55-1.3,5.86-0.65,8.46c0.65,2.6,4.55,3.25,5.21,9.76 c0.65,6.51-1.95,5.86-1.3,9.76s4.55,3.9,5.21,7.16c0.65,3.25,0.65,7.81,1.95,11.71c1.3,3.9,5.21,9.76,7.16,9.76 c1.95,0,7.16-11.06,5.86-14.32c-1.3-3.25-3.25-3.9-3.25-6.51c0-2.6,2.6-9.11,1.95-13.66c-0.65-4.55-6.51-6.51-7.16-9.76 c-0.65-3.25,1.3-11.71-3.25-15.62S347.06,329.37,346.41,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M367.58,396.58c-0.18,0-0.32-0.14-0.33-0.32c0-0.09-0.06-8.54-2.53-11.02 c-2.51-2.51-3.95-10.21-4.65-24.94c-0.64-13.39-10.23-24.42-10.33-24.53c-0.12-0.13-0.11-0.34,0.03-0.46 c0.14-0.12,0.34-0.11,0.46,0.03c0.1,0.11,9.84,11.3,10.49,24.93c0.68,14.36,2.1,22.15,4.46,24.51 c2.67,2.67,2.72,11.12,2.72,11.48C367.91,396.43,367.76,396.58,367.58,396.58C367.59,396.58,367.59,396.58,367.58,396.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M405.97,342.47c2.3,2.3-5.21,3.25-5.86,7.81s-0.65,6.51-3.25,9.11c-2.6,2.6-6.51,3.25-5.86,7.16 c0.65,3.9,1.95,7.81,0,9.76c-1.95,1.95-6.51,1.95-7.81,5.21c-1.3,3.25-0.65,7.16-3.25,10.41c-2.6,3.25-6.51,9.76-9.76,8.46 c-3.25-1.3-1.3-16.27,0-18.87c1.3-2.6,2.6-4.55,2.6-6.51c0-1.95-0.65-5.21,0.65-8.46c1.3-3.25,8.46-4.55,9.11-6.51 c0.65-1.95,1.3-12.36,5.21-14.97C391.66,342.47,402.07,338.57,405.97,342.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M371.19,399.27c-0.06,0-0.11-0.01-0.17-0.05c-0.15-0.09-0.2-0.29-0.11-0.45c0.03-0.04,2.63-4.4,3.18-6.6 c0.14-0.57,0.31-1.43,0.51-2.42c0.72-3.61,1.81-9.07,3.48-10.74c2.43-2.43,6.31-9.86,9.03-19.38 c3.35-11.72,14.42-15.16,14.53-15.19c0.18-0.05,0.35,0.05,0.4,0.22c0.05,0.17-0.05,0.35-0.22,0.4 c-0.11,0.03-10.85,3.37-14.1,14.74c-2.75,9.62-6.71,17.17-9.19,19.66c-1.53,1.53-2.64,7.09-3.3,10.41 c-0.2,1-0.37,1.87-0.52,2.45c-0.57,2.3-3.15,6.6-3.26,6.78C371.41,399.21,371.3,399.27,371.19,399.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M370.36,349.92c-7.81,0.65-5.21,24.08-5.21,24.08c1.95,20.17,4.55,29.28,6.51,29.93 c1.95,0.65,5.86-28.63,5.86-35.79C377.52,368.14,378.17,349.27,370.36,349.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M371.34,400.68c-0.01,0-0.03,0-0.04,0c-0.18-0.02-0.3-0.18-0.28-0.36c2.57-21.19-0.62-47.81-0.65-48.07 c-0.02-0.18,0.1-0.34,0.28-0.36c0.17-0.03,0.34,0.1,0.36,0.28c0.03,0.27,3.23,26.96,0.65,48.23 C371.64,400.56,371.5,400.68,371.34,400.68z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M381.04,415.49h-19.8c-0.66,0-1.22-0.4-1.29-0.94l-2.88-20.53c-0.13-0.92,0.59-1.75,1.52-1.75h25.1 c0.93,0,1.65,0.83,1.52,1.75l-2.88,20.53C382.26,415.09,381.7,415.49,381.04,415.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M124.36,198.74c0,0-5.6-4.73-6.01-4.43c-0.42,0.3,0.23,2.99,0.23,2.99s-3.78-2.84-5.41-1.25 c-1.63,1.59,3.22,12.18,7.98,13.47L124.36,198.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M314.52,193.28c0,0,5.6-4.73,6.01-4.43c0.42,0.3-0.23,2.99-0.23,2.99s3.78-2.84,5.41-1.25 c1.63,1.59-3.22,12.18-7.98,13.47L314.52,193.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099657848439015529310000006065988481628687767_",
    gradientUnits: "userSpaceOnUse",
    x1: 5073.1934,
    y1: 401.9241,
    x2: 5103.5107,
    y2: 401.9241,
    gradientTransform: "matrix(1 0 0 1 -4892.647 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9662,
    style: {
      stopColor: "#FF9F91"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000099657848439015529310000006065988481628687767_)"
    },
    points: "180.55,398.31 180.55,406.86 209.8,406.86 210.86,396.99  "
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M180.55,406.86l-5.46,6.18c-0.46,0.52-0.47,1.2-0.17,1.72c0.25,0.43,0.7,0.74,1.28,0.74h31.54 c0.29,0,0.55-0.11,0.75-0.28c0.2-0.18,0.34-0.43,0.37-0.71l0.94-7.64H180.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168802204296384969290000012095806788175350453_",
    gradientUnits: "userSpaceOnUse",
    x1: -368.5212,
    y1: 401.9155,
    x2: -337.8037,
    y2: 401.9155,
    gradientTransform: "matrix(-1 0 0 1 -106.518 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9662,
    style: {
      stopColor: "#FF9F91"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168802204296384969290000012095806788175350453_)"
    },
    points: "261.16,398.27 262,406.86 232.75,406.86 231.29,396.98  "
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M262,406.86l5.46,6.18c0.46,0.52,0.47,1.2,0.17,1.72c-0.25,0.43-0.7,0.74-1.28,0.74h-31.54 c-0.29,0-0.55-0.11-0.75-0.28c-0.2-0.18-0.34-0.43-0.37-0.71l-0.94-7.64H262z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M195.24,249.14c0,0-11.2,38.17-13.28,67.21c-2.07,29.04-1.98,82.92-1.98,82.92h31.25 c0,0,7.31-73.58,10.21-73.85c2.9-0.26,8.7,73.85,8.7,73.85h32.7c0,0-7.36-126.7-19.04-150.13H195.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047770310393760486110000004834822490288400536_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.4865,
    y1: 228.5373,
    x2: 321.611,
    y2: 228.5373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047770310393760486110000004834822490288400536_)"
    },
    d: "M321.61,202.51l-7.12-10.4 c-12.41,7.12-29.92,7.48-51.27,1.64c-15.63-4.27-26.54-8.94-44.01-8.94c-17.47,0-34.64,12.36-43.34,14.74 c-21.35,5.84-38.86,5.47-51.27-1.64l-7.12,10.4c0,0,29.12,24.56,72.17,17.96c-1.06,14.45-3.44,36.54-2.71,39.94 c1.72,8,61.72,8.36,64.62-0.75c0.85-2.67-3.17-30.69-3.78-45.26C291.75,227.7,321.61,202.51,321.61,202.51z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M235.05,171.25l0.13,9.01l-1.34-0.04c0,0-1.08,7.45-6.34,6.28c-1.51-0.34-3.44-1.62-4-1.36 c-0.66,0.3-0.95,2.34-1.09,2.93c-0.57,2.26-8.47-0.02-7.19-2.34c1.22-2.19,3.03-5.19,2.64-6.03c-1.34-2.9-1.72-10.11,5.54-12.52 C229.18,165.26,234.99,168.17,235.05,171.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M215.22,185.73c1.22-2.19,3.03-5.19,2.64-6.03c0,0,3.05,4.69,5.86,5.4c0.01,0,0.01,0,0.01,0.01 c-0.09-0.01-0.17,0-0.24,0.03c-0.66,0.3-0.95,2.34-1.09,2.93C221.84,190.32,213.94,188.04,215.22,185.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M222.87,175.67c-3.39-0.58-1.28,6.98-5.02,6.73c-3.74-0.25-6.34-8.42-3.6-14.72 c2.74-6.3,7.96-5.95,12.93-5.09c4.97,0.86,11.07,3.11,11.06,6.87c-0.01,9.05-10.71,1.46-11.42,4.18 c-0.55,2.1-1.39,8.19,0.79,8.33c2.18,0.14,4.4-1.66,6.12-1.2c0.99,0.27,3.72,12.13-3.41,12.53c-7.06,0.39-8.84-5.84-7.36-10.93 C224.38,177.52,224.53,175.96,222.87,175.67z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M370.3,228.94c-0.55,0-1.06-0.35-1.23-0.9c-3.3-10.57-7.66-16.55-12.96-17.76 c-3.53-0.81-6.54,0.74-9.72,2.38c-3.16,1.63-6.43,3.32-10.32,2.62c-7.75-1.39-13.61-11.47-17.93-30.82 c-0.15-0.69,0.28-1.38,0.97-1.53c0.7-0.16,1.38,0.28,1.53,0.97c4.01,17.97,9.35,27.68,15.87,28.85c3.03,0.54,5.78-0.88,8.69-2.38 c3.29-1.7,7.02-3.62,11.47-2.6c6.26,1.43,11.25,7.99,14.84,19.5c0.21,0.68-0.17,1.4-0.84,1.61 C370.55,228.92,370.43,228.94,370.3,228.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M326.87,180.76c-2.21,5.43-8.41,8.04-13.84,5.83c-4.65-1.89-7.23-6.71-6.49-11.47 c0.12-0.8,17.75-6.32,18.86-4.91C327.66,173.11,328.36,177.11,326.87,180.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M318.74,160.59L318.74,160.59c0.73-0.2,1.48,0.24,1.68,0.96l2.76,10.24c0.2,0.73-0.24,1.48-0.96,1.68l0,0 c-0.73,0.2-1.48-0.24-1.68-0.96l-2.76-10.24C317.58,161.54,318.02,160.78,318.74,160.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M307.76,163.55L307.76,163.55c0.73-0.2,1.48,0.24,1.68,0.96l2.76,10.24c0.2,0.73-0.24,1.48-0.96,1.68h0 c-0.73,0.2-1.48-0.24-1.68-0.96l-2.76-10.24C306.6,164.5,307.04,163.74,307.76,163.55z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M322.41,177.52l-9.46,2.46c-4.4,1.14-8.93-1.52-10.07-5.91l0,0c-0.29-1.11,0.38-2.24,1.49-2.53l21.42-5.57 c1.11-0.29,2.24,0.38,2.53,1.49l0,0C329.47,171.85,326.81,176.38,322.41,177.52z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M112.68,277.76c-0.27,0-0.55-0.09-0.78-0.27c-9.98-7.71-14.77-15.16-14.24-22.17 c0.55-7.09,6.22-11.72,11.71-16.2c5.68-4.64,11.05-9.01,11.34-15.88c0.17-3.93-1.44-6.52-3.13-9.26 c-1.83-2.96-3.73-6.03-3.35-10.72c0.67-8.27,8.11-15.91,22.11-22.69c0.64-0.31,1.41-0.04,1.72,0.6c0.31,0.64,0.04,1.41-0.6,1.72 c-13.12,6.36-20.08,13.28-20.67,20.58c-0.31,3.84,1.28,6.42,2.97,9.15c1.74,2.81,3.72,6,3.52,10.72 c-0.34,8.02-6.41,12.97-12.28,17.76c-5.3,4.33-10.31,8.41-10.77,14.4c-0.47,6.08,3.99,12.79,13.24,19.93 c0.56,0.43,0.67,1.24,0.23,1.8C113.45,277.59,113.07,277.76,112.68,277.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M144.66,190.39c-5.45,1.24-10.88-2.17-12.12-7.63c-1.24-5.45,2.17-10.88,7.63-12.12 c5.45-1.24,10.88,2.17,12.12,7.63C153.53,183.72,150.12,189.14,144.66,190.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M155.91,190.62c-2.16,0.49-5.18-4.72-6.76-11.64s-1.11-12.93,1.05-13.42c2.16-0.49,5.18,4.72,6.76,11.64 C158.53,184.12,158.06,190.13,155.91,190.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M141.7,181.68l-0.44-1.92c-1.45-6.36,2.57-12.76,8.94-14.21l0,0l5.71,25.06l0,0 C149.54,192.07,143.15,188.05,141.7,181.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M155.32,188.06c-1.72,0.39-4.12-3.76-5.38-9.26c-1.25-5.51-0.88-10.29,0.84-10.68 c1.72-0.39,4.12,3.76,5.38,9.26C157.41,182.89,157.04,187.67,155.32,188.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M152.54,175.25c-0.29,0.07-0.7-0.64-0.92-1.58c-0.21-0.94-0.15-1.75,0.14-1.82 c0.29-0.07,0.7,0.64,0.92,1.58C152.9,174.37,152.83,175.19,152.54,175.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M154.59,184.26c-0.29,0.07-0.7-0.64-0.92-1.58c-0.21-0.94-0.15-1.75,0.14-1.82 c0.29-0.07,0.7,0.64,0.92,1.58C154.95,183.38,154.88,184.19,154.59,184.26z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnplugged);
export default __webpack_public_path__ + "static/media/unplugged.29cc660a7f34ea6f8df4f967b43e323f.svg";
export { ForwardRef as ReactComponent };